export default __webpack_public_path__ + "static/media/ping.14568d67.mp3";